'use strict';

const AgentAvailableTemplate = require('../templates/AgentAvailable.hbs');
const AgentPromoTemplate = require('../templates/AgentPromo.hbs');
const AgentProfileStatus = require('../templates/AgentProfile.hbs');
const AgentProfileButtons = require('../templates/AgentProfileButtons.hbs');
const AgentProfileButtonsDesktop = require('../templates/AgentProfileButtonsDesktop.hbs');
const AgentUnavailableTemplate = require('../templates/AgentUnavailable.hbs');

const agentStateTemplateFactory = {

  // Get the View based on type
  getTemplateByState: function(state) {
    switch (state) {
      case 'video':
      case 'text':
        return AgentAvailableTemplate;
      case 'unavailable':
        return AgentUnavailableTemplate;
      case 'promo':
        return AgentPromoTemplate;
      case 'profile-status':
        return AgentProfileStatus;
      case 'profile-buttons':
        return AgentProfileButtons;
      case 'profile-buttons-desktop':
        return AgentProfileButtonsDesktop;
      default:
        return AgentAvailableTemplate;
    }
  }

};

module.exports = agentStateTemplateFactory;



// WEBPACK FOOTER //
// ./assets/components/VideoDesk/views/agentStateTemplateFactory.js